// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.floorplans.photos.RentalManagerUserPropertyFloorPlanPhotoWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  ListingAlias,
  UserPropertyFloorPlanPhotoDeleteForFeedRequestWebDto,
  UserPropertyFloorPlanPhotoUploadRequestWebDto,
  UserPropertyFloorPlanPhotoUploadResponseWebDto,
} from '../..';

interface UploadParams {
  floorPlanId: string;
  sourceUrl?: string;
}
interface UploadForFeedParams {
  floorPlanId: string;
  listingAlias: ListingAlias;
  sourceUrl?: string;
}

export const RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_deleteForFeed_Path =
  '/api/web/v1/users/properties/floorPlans/photos/deleteForFeed';

/**
 * Delete an uploaded photo from a floor plan of a feed listing
 */
export const RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_deleteForFeed = (
  postData: UserPropertyFloorPlanPhotoDeleteForFeedRequestWebDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyFloorPlanPhotoDeleteForFeedRequestWebDto, void>(
    {
      endpoint: RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_deleteForFeed_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_upload_Path =
  '/api/web/v1/users/properties/floorPlans/photos/upload';

/**
 * Upload a photo for a floor plan
 */
export const RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_upload = (
  getParams: UploadParams,
  postData: UserPropertyFloorPlanPhotoUploadRequestWebDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    UploadParams,
    UserPropertyFloorPlanPhotoUploadRequestWebDto,
    UserPropertyFloorPlanPhotoUploadResponseWebDto
  >(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_upload_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
      isFormData: true,
    },
    client,
  );
};

export const RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_uploadForFeed_Path =
  '/api/web/v1/users/properties/floorPlans/photos/uploadForFeed';

/**
 * Upload a photo onto a floor plan of a feed listing
 */
export const RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_uploadForFeed = (
  getParams: UploadForFeedParams,
  postData: UserPropertyFloorPlanPhotoUploadRequestWebDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    UploadForFeedParams,
    UserPropertyFloorPlanPhotoUploadRequestWebDto,
    UserPropertyFloorPlanPhotoUploadResponseWebDto
  >(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyFloorPlanPhotoWebApiHandler_uploadForFeed_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
      isFormData: true,
    },
    client,
  );
};
